/**
 * cart-pallet.js  (v6 - settings driven, fast)
 * Auto add / change / remove pallet products by total cart weight.
 * Works on page load, cart drawer and cart page (qty plus / minus / typed qty, remove, add to cart).
 *
 * Products, weight limits and quantities come from Theme settings > "Cart pallet"
 * (through the snippet cart-pallet-config.liquid -> window.CART_PALLET_CONFIG).
 * If that config is missing, the built-in defaults below are used:
 *
 *   < 25 kg            -> no pallet
 *   25 - 80 kg         -> 1 x SKU 1.090247
 *   > 80 and < 900 kg  -> 1 x SKU 3.000753
 *   >= 900 kg          -> 2 x SKU 3.000753
 *
 * Debug: open the browser console and look for lines starting with [cart-pallet].
 */
(function () {
  if (window.__cartPalletLoaded) return;
  window.__cartPalletLoaded = true;

  var DEBUG = true;   // console logs ON (set false for production, or toggle in the console: cartPalletDebug(false))
  try { if (/[?&]pallet_debug=0/.test(location.search)) DEBUG = false; } catch (e) {}
  var DELAY = 120;    // ms to wait after a cart request (lets the theme finish its own render first)

  var KG = 1000; // cart.js weights are in grams
  var CFG = window.CART_PALLET_CONFIG || null;

  /* ------------------------------------------------------------------
   * Config: from theme settings, or built-in defaults
   * PALLETS : key (SKU, or "v<variantId>" when the variant has no SKU) -> { variantId, productHandle }
   * TIERS   : t1 / t2 / t3 -> { key, qty }
   * LIMITS  : min / mid / high weight in kg
   * ------------------------------------------------------------------ */
  var PALLETS = {};
  var TIERS = { t1: null, t2: null, t3: null };
  var LIMITS = { min: 25, mid: 80, high: 900 };

  if (CFG) {
    LIMITS.min = Number(CFG.minKg) || 25;
    LIMITS.mid = Number(CFG.midKg) || 80;
    LIMITS.high = Number(CFG.highKg) || 900;

    var DEFAULT_SKUS = [['1.090247', 1], ['3.000753', 1], ['3.000753', 2]];
    ['tier1', 'tier2', 'tier3'].forEach(function (name, i) {
      var t = CFG[name] || {};
      var sku = String(t.sku || '').trim();
      var vid = Number(t.variantId) || 0;
      var key = sku || (vid ? 'v' + vid : '');
      var qty = Math.max(1, Number(t.qty) || DEFAULT_SKUS[i][1]);
      if (!key) {
        // no product selected in theme settings -> fall back to the default SKU (found by search)
        key = DEFAULT_SKUS[i][0];
        vid = 0;
        console.warn('[cart-pallet] No product selected for ' + name + ' in Theme settings > Cart pallet (and saved). Using default SKU ' + key + '.');
      }
      PALLETS[key] = PALLETS[key] || { variantId: vid, productHandle: '' };
      TIERS['t' + (i + 1)] = { key: key, qty: qty };
    });
    log('config', JSON.stringify(CFG));
  } else {
    PALLETS['1.090247'] = { variantId: 0, productHandle: '' };
    PALLETS['3.000753'] = { variantId: 0, productHandle: '' };
    TIERS.t1 = { key: '1.090247', qty: 1 };
    TIERS.t2 = { key: '3.000753', qty: 1 };
    TIERS.t3 = { key: '3.000753', qty: 2 };
  }

  function getRule(grams) {
    var t = null;
    if (grams >= LIMITS.high * KG) t = TIERS.t3;
    else if (grams > LIMITS.mid * KG) t = TIERS.t2;
    else if (grams >= LIMITS.min * KG) t = TIERS.t1;
    return t ? { sku: t.key, qty: t.qty } : null;
  }

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CART_URL = root + 'cart.js';
  var ADD_URL = root + 'cart/add.js';
  var UPDATE_URL = root + 'cart/update.js';
  var SKUS = Object.keys(PALLETS);
  var origFetch = window.fetch.bind(window); // own calls use this -> never trigger the watcher

  log('loaded', CFG ? 'theme settings config' : 'default SKU config', JSON.stringify(PALLETS), JSON.stringify(LIMITS));

  var running = false, queued = false, timer = null, pendingCart = null, lastRun = 0;

  function log() {
    if (!DEBUG) return;
    var args = ['[cart-pallet]'];
    for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
    console.log.apply(console, args);
  }
  window.cartPalletDebug = function (on) { DEBUG = on !== false; console.log('[cart-pallet] debug ' + (DEBUG ? 'ON' : 'OFF')); };
  function jsonHeaders() {
    return { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  }

  // which pallet key (if any) does this cart line belong to?
  function palletKeyForItem(item) {
    var sku = String(item.sku || '').trim();
    if (sku && PALLETS.hasOwnProperty(sku)) return sku;
    for (var k in PALLETS) {
      if (PALLETS.hasOwnProperty(k) && PALLETS[k].variantId && Number(PALLETS[k].variantId) === item.variant_id) return k;
    }
    return null;
  }

  /* ------------------------------------------------------------------
   * Find the variant ID for a SKU
   * ------------------------------------------------------------------ */
  var idCache = {};
  try { idCache = JSON.parse(sessionStorage.getItem('cartPalletIds') || '{}'); } catch (e) {}
  function saveId(sku, id) {
    idCache[sku] = id;
    try { sessionStorage.setItem('cartPalletIds', JSON.stringify(idCache)); } catch (e) {}
    return id;
  }

  function variantFromHandle(handle, sku) {
    return origFetch(root + 'products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return 0;
        var v = p.variants.filter(function (x) { return String(x.sku).trim() === sku; })[0];
        return v ? v.id : 0;
      })
      .catch(function () { return 0; });
  }

  // 1) storefront search by SKU (tries with and without the sku field option)
  function searchOnce(sku, withFields) {
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(sku) +
      '&resources[type]=product&resources[limit]=10' +
      (withFields ? '&resources[options][fields]=variants.sku,title' : '');
    return origFetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        var chain = Promise.resolve(0);
        products.forEach(function (p) {
          chain = chain.then(function (found) { return found || variantFromHandle(p.handle, sku); });
        });
        return chain;
      })
      .catch(function () { return 0; });
  }
  function findBySearch(sku) {
    return searchOnce(sku, true).then(function (id) { return id || searchOnce(sku, false); });
  }

  // 2) scan all products (collections/all/products.json) for the SKU
  function findByScan(sku) {
    function page(n) {
      if (n > 10) return Promise.resolve(0);
      return origFetch(root + 'collections/all/products.json?limit=250&page=' + n)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.products || !data.products.length) return 0;
          for (var i = 0; i < data.products.length; i++) {
            var vs = data.products[i].variants || [];
            for (var j = 0; j < vs.length; j++) {
              if (String(vs[j].sku).trim() === sku) return vs[j].id;
            }
          }
          return page(n + 1);
        })
        .catch(function () { return 0; });
    }
    return page(1);
  }

  function resolveVariantId(sku, cart) {
    if (window.CART_PALLET_VARIANTS && window.CART_PALLET_VARIANTS[sku]) {
      return Promise.resolve(saveId(sku, Number(window.CART_PALLET_VARIANTS[sku])));
    }

    var cfg = PALLETS[sku];
    // variant chosen in theme settings always wins
    if (cfg.variantId) return Promise.resolve(saveId(sku, Number(cfg.variantId)));

    if (idCache[sku]) return Promise.resolve(idCache[sku]);

    var inCart = cart.items.filter(function (i) { return String(i.sku).trim() === sku; })[0];
    if (inCart) return Promise.resolve(saveId(sku, inCart.variant_id));

    var start = cfg.productHandle ? variantFromHandle(cfg.productHandle, sku) : Promise.resolve(0);
    return start
      .then(function (id) { return id || findBySearch(sku); })
      .then(function (id) { return id || findByScan(sku); })
      .then(function (id) {
        if (id) { log('SKU ' + sku + ' -> variant ' + id); return saveId(sku, id); }
        console.warn('[cart-pallet] Could not find a product with SKU ' + sku +
          '. Make sure it is Active and published to the Online Store, or select it in Theme settings > Cart pallet.');
        return 0;
      });
  }

  /* ------------------------------------------------------------------
   * Refresh drawer / cart page UI
   * ------------------------------------------------------------------ */
  function refreshUI() {
    var base = window.cartBase;
    if (base && typeof base.refreshCart === 'function') {
      return base.refreshCart();
    }
    if (window.location.pathname.indexOf('/cart') !== -1) window.location.reload();
  }

  function postJson(url, body) {
    return origFetch(url, { method: 'POST', headers: jsonHeaders(), body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }

  // Final request: applies the pallet changes AND returns the re-rendered drawer / cart page sections,
  // so the screen is updated with one request (no separate refresh round trip).
  function commitAndRender(updateMap) {
    var base = window.cartBase;
    var body = { updates: updateMap || {} };
    if (base && typeof base.getSectionsToRender === 'function' && typeof base.updateSections === 'function') {
      body.sections = base.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    return postJson(UPDATE_URL, body).then(function (res) {
      if (res.status || res.errors) {
        console.warn('[cart-pallet] update failed:', res.errors || res.description);
        return false;
      }
      if (body.sections && res.sections) {
        try {
          base.cartData = res;
          base.updateSections(res);
          return true;
        } catch (e) { /* fall through to the safe refresh */ }
      }
      refreshUI();
      return true;
    });
  }

  /* ------------------------------------------------------------------
   * Main sync
   * ------------------------------------------------------------------ */
  function sync(cartIn) {
    if (window.Shopify && Shopify.designMode) return;
    if (CFG && CFG.enabled === false) return; // switched off in theme settings
    if (!SKUS.length) return;
    if (running) { queued = true; return; }
    running = true;
    lastRun = Date.now();

    // use the cart already returned by the theme's change/update request when we have it (saves a request)
    var cartPromise = (cartIn && cartIn.items)
      ? Promise.resolve(cartIn)
      : origFetch(CART_URL, { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });

    cartPromise
      .then(function (cart) {
        var grams = 0;
        var current = {};
        SKUS.forEach(function (s) { current[s] = 0; });

        cart.items.forEach(function (item) {
          var key = palletKeyForItem(item);
          if (key) {
            current[key] += item.quantity;
          } else {
            grams += (item.grams || 0) * item.quantity;
          }
        });

        var rule = getRule(grams);
        var desired = {};
        SKUS.forEach(function (s) { desired[s] = rule && rule.sku === s ? rule.qty : 0; });

        log('weight: ' + (grams / KG) + ' kg | pallets in cart:', JSON.stringify(current), '| wanted:', JSON.stringify(desired));

        var changed = SKUS.filter(function (s) { return current[s] !== desired[s]; });
        if (!changed.length) return null;
        log('changing pallets:', changed.join(', '));

        return Promise.all(changed.map(function (s) { return resolveVariantId(s, cart); })).then(function (ids) {
          var updateMap = {};   // existing lines: change qty / remove
          var addItems = [];    // new lines: add
          changed.forEach(function (s, i) {
            var id = ids[i];
            if (!id) return;
            if (current[s] > 0) updateMap[id] = desired[s];
            else if (desired[s] > 0) addItems.push({ id: id, quantity: desired[s] });
          });

          // 1) add the NEW pallet first (only if needed)
          var chain = Promise.resolve(true);
          if (addItems.length) {
            chain = postJson(ADD_URL, { items: addItems }).then(function (res) {
              if (res.status || res.errors) {
                console.warn('[cart-pallet] ADD failed for', JSON.stringify(addItems), '->', res.description || res.message || res.errors, res);
                return false;
              }
              log('added pallet', JSON.stringify(addItems));
              return true;
            });
          }
          // 2) then remove / change the OLD pallet and render the screen in ONE request.
          //    If the add failed, the old pallet is kept.
          return chain.then(function (addOk) {
            if (!addOk) { log('old pallet kept because the new pallet could not be added'); return false; }
            log('updating pallet lines', JSON.stringify(updateMap));
            return commitAndRender(updateMap);
          });
        });
      })
      .catch(function (e) { console.error('[cart-pallet]', e); })
      .then(function () {
        running = false;
        if (queued) { queued = false; schedule(60); }
      });
  }

  function schedule(delay, cart) {
    clearTimeout(timer);
    pendingCart = cart || null;
    timer = setTimeout(function () {
      var c = pendingCart;
      pendingCart = null;
      sync(c);
    }, delay == null ? DELAY : delay);
  }

  /* ------------------------------------------------------------------
   * Watch every cart request: add / change / update / clear
   * ------------------------------------------------------------------ */
  var CART_REQ = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;

  var FULL_CART_REQ = /\/cart\/(change|update)(\.js|\.json)?(\?|$)/;

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(window, arguments);
    if (CART_REQ.test(url)) {
      var full = FULL_CART_REQ.test(url);
      p.then(function (res) {
        if (full && res && res.ok) {
          try {
            // change / update return the whole cart -> reuse it, no extra /cart.js request
            res.clone().json().then(
              function (c) { schedule(DELAY, c && c.items ? c : null); },
              function () { schedule(DELAY); }
            );
            return;
          } catch (e) { /* body already used -> normal path */ }
        }
        schedule(DELAY);
      }, function () {});
    }
    return p;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && CART_REQ.test(url)) {
      this.addEventListener('loadend', function () { schedule(DELAY); });
    }
    return xhrOpen.apply(this, arguments);
  };

  var themeHooked = false;
  function hookThemeEvents() {
    if (themeHooked) return;
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      themeHooked = true;
      ['cartUpdateFinish', 'quantityUpdateFinish', 'cartUpdate', 'quantityUpdate'].forEach(function (name) {
        if (PUB_SUB_EVENTS[name]) window.subscribe(PUB_SUB_EVENTS[name], function () { schedule(DELAY); });
      });
    }
  }

  function init() {
    hookThemeEvents();
    schedule(0); // check right away on load
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // theme scripts (subscribe / PUB_SUB_EVENTS) may only exist after full load; hook once more, but don't re-check needlessly
  window.addEventListener('load', function () {
    hookThemeEvents();
    if (Date.now() - lastRun > 1500) schedule(0);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(0); });

  window.cartPalletSync = function () { schedule(0); }; // manual test: run cartPalletSync() in the console

  if (window.scriptController && Array.isArray(scriptController.scripts)) scriptController.scripts.push('cart-pallet.js');
})();